export default "__VITE_ASSET__CdGmL2EG__"